module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.loadingMap) ? _c('div', {
    staticClass: "overlay"
  }, [_c('img', {
    staticClass: "loading-animation",
    attrs: {
      "src": require("../assets/squares.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "map"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-633d49ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 443
// module chunks = 1